import { useMemo } from 'react'

import { getFullySelectedNodes } from '@/components/TreeV2'
import { StructureObjectDto } from '@/endpoints/models'
import { useAppStore } from '@/hooks'

import { BatchEditSelectType } from './BatchEditSelectType'
import { BatchEditContextProvider } from './context/BatchEditContext'

type Props = {
	node: StructureObjectDto,
	onClose: () => void
}

export const BatchEdit = ({ onClose, node }: Props) => {
	const selectedNodes = useAppStore((state) => state.node.selectedNodes)
	const children = useAppStore((state) => state.node.children)
	const nodes = useAppStore((state) => state.node.nodes)

	// Filter out partially selected folders (indeterminate state)
	const fullySelectedNodes = useMemo(
		() => getFullySelectedNodes(selectedNodes, children, nodes),
		[selectedNodes, children, nodes],
	)

	return (
		<BatchEditContextProvider
			initialState={{
				formChanged: {},
				onClose,
				locking: false,
				submitting: false,
				errors: {},
				selectedNodes: fullySelectedNodes,
				node,
			}}
		>
			<BatchEditSelectType />
		</BatchEditContextProvider>
	)
}
